/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
export const isOverridingFragments = (): boolean => {
	const re = /^(JF-TEST|MRJF-BB(\d+)?-\d+)$/;
	const buildKey = typeof window !== 'undefined' ? window?.BUILD_KEY : globalThis?.BUILD_KEY;
	return buildKey ? re.test(buildKey) : false;
};
